import { useState, useEffect, useContext } from "react"
// eslint-disable-next-line
import { Button, CircularProgress } from "@mui/material"
import { useParams } from "react-router-dom"

import LupeReyes from "../Media/Images/lupe-reyes.png"
import info from "../Media/Images/info.png"

import "../Styles/Pages.scss"
import axios from "axios"
import ContextP from "../Context/Context"
import DetailOrder from "../Components/DetailOrder"
import ListCoupons from "../Components/ListCoupons";
import star from "../Media/Images/stars.png"
import Instructions from "../Components/Instructions"

const Summary: React.FC = () => {
    const context = useContext(ContextP)
    const { id } = useParams()
    const [loader, setLoader] = useState(true)
    const [error, setError] = useState(false)
    const [show, setShow] = useState(false)
    const [showList, setShowList] = useState(false)
    const [showInstruction, setShowInstruction] = useState(false)
    const [user, setUser] =useState({  
        token:"",
        name:"",
        lastName:"",
        countryCode:"",
        email:"",
        storeKey:""
    })
    const [data, setData] = useState<any>()
    const [listCoupon, setListCoupon] = useState<any>()
    const [dataProps, setDataProps] = useState<any>()
    const [days, setDays] = useState<any>()
    const categories = [
      'wines', 'beers', 'box', 'extras', 'hotdeals', 'liquors', 'non-alcoholic', 'P3SQxBTwaqxt03wJ3Jtu'
    ];

    useEffect(()=>{
        getData()
    // eslint-disable-next-line
    },[])

    const getData = async () => {

        // Obtiene la informacion del usuario
        let body = {
            token: id
        }

        // Obtiene la informacion del usuario
        await axios.post(`${ process.env.REACT_APP_URL }/accounts/get/user`, body).then((response)=>{
            let data = response.data.data
            setUser({
                token: id !== undefined ? id : "",
                name: data.name ? data.name : "",
                lastName: data.lastname ? data.lastname : "",
                countryCode: data.country ? data.country : "",
                email: data.email ? data.email : "",
                storeKey: data.store ? data.store : "",
            })
            context.assignateUser(user)

        }).catch((error)=>{
            console.log(error)
            setError(true)
            setLoader(false)
        })

        // Obtiene la informacion de las ordenes
        if ( !error ) {
            await axios.post(`${ process.env.REACT_APP_URL }/service/barlleno/orders/dynamic/game`, body).then((response)=>{
                
                setDays(response.data.data.days)
                setData(response.data.data.matriz)
                setListCoupon(response.data.data.listCoupons)
                setShowList( response.data.data.listUserCoupon.length > 0 )
                setLoader(false)

            }).catch((errors)=>{
                setError(true)
                setLoader(false)
            })
        }
    }

    // Muestra el item que se selecciono
    const showDetail = async (item: any) => {
      setLoader(true);
      const body = {
        token: id,
        data: {
          countryCode: user.countryCode,
          storeKey: user.storeKey,
          categoryKey: item.brick,
          type: ["brick", "reference"],
        },
      };
      if(item.brick.length !== 0){
        if(!categories.includes(item.brick)){
          await axios
          .post(`${process.env.REACT_APP_URL}/service/bricks/get/brickbyID`, {
            token: id,
            data: { $key: item.brick },
          })
          .then(async (result) => {
            if (result.data.data.type === "category") {
              await axios
                .post(
                  `${process.env.REACT_APP_URL}/service/bricks/get/category/bricks`,
                  body
                )
                .then((resultProducts: any) => {
                  setDataProps({
                    bricks: resultProducts.data.data,
                    type: "category",
                  });
                  setShow(true);
                  setLoader(false);
                })
                .catch(() => {
                  setError(true);
                  setLoader(false);
                });
            } else {
              setDataProps({ bricks: [result.data.data], type: "brick" });
              setShow(true);
              setLoader(false);
            }
          })
          .catch(() => {
            setError(true);
            setLoader(false);
          });
        }else{
          const sections = [
            {
              id: 'beers',
              name: 'Cervezas & Seltzer'
            },
            {
              id: 'extras',
              name: 'Market'
            },
            {
              id: 'non-alcoholic',
              name: 'Sin alcohol'
            },
            {
              id: 'wines',
              name: 'Vinos'
            },
            {
              id: 'P3SQxBTwaqxt03wJ3Jtu',
              name: 'Mezcales en Destilados'
            },
          ]
  
          let section = sections.filter((section)=> section.id === item.brick);
          setDataProps({ bricks: [], type: "section", section: section.length > 0 ? section[0] : {} });
          setShow(true);
          setLoader(false);
        }
      }else{
          setDataProps({ bricks: [], type: "nothing" });
          setShow(true);
          setLoader(false);
      }
      
      
    };

    const showListCoupon = ( ) => {
        setShowList(true)
        console.log(listCoupon)
    }

    const showInstructionHandle = ( ) => {
        setShowInstruction(true)
    }
    return (
      <>
        <DetailOrder open={show} setOpen={setShow} data={dataProps} />
        <ListCoupons open={showList} setOpen={setShowList} data={listCoupon} />
        <Instructions open={showInstruction} setOpen={setShowInstruction} />
        {loader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}>
            <CircularProgress style={{ color: "white " }} />
          </div>
        ) : error ? (
          <div
            style={{ textAlign: "center", marginTop: "40%", color: "white" }}>
            <h1>Algo salio mal, intentelo mas tarde.</h1>
          </div>
        ) : (
          <div className="summary-root">
            <div style={{ position: "relative" }}>
              <img src={LupeReyes} alt="Lupe-Reyes logo" />
              <img
                onClick={showInstructionHandle}
                style={{
                  position: "absolute",
                  width: 50,
                  height: 50,
                  top: 0,
                  right: 5,
                }}
                src={info}
                alt="Info logo"></img>
            </div>

            <div className="container-matriz">
              {days.map((item: any, index: number) => {
                return (
                  <div key={index} className="item-matriz">
                    <div className="item-matriz-header">
                      <p>{item.day}</p>
                    </div>

                    {item.bonus ? (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                        onClick={() => showDetail(item)}>
                        <div
                          style={{
                            position: "relative",
                            background:
                              "linear-gradient(73deg, #EA3434 27.49%, #C81F1F 51.6%, #AB0E0E 75.72%, #A00808 90.19%)",
                            padding: "20%",
                            borderRadius: "200px",
                          }}>
                          <div
                            style={{
                              paddingInline: "15.5px",
                              paddingBlock: "15.5px",
                            }}></div>
                          <svg
                            style={{ position: "absolute", top: 'calc(50% - 37.5px)', left: 'calc(50% - 29px)' }}
                            width={58}
                            height={75}
                            id="Capa_2"
                            data-name="Capa 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 169.9 154.67">
                            <g id="Capa_1-2" data-name="Capa 1">
                              <g>
                                <path
                                  style={{ fill: "#361c4c" }}
                                  d="m147.92,152.17c-.65,0-1.31-.06-1.96-.17-3.01-.52-5.64-2.18-7.4-4.68s-2.44-5.53-1.92-8.54c.35-2,1.23-3.88,2.54-5.43-.89-3.29-2.38-10.01-1.78-16.23.34-3.51,1.68-7.18,2.98-10.73,1.65-4.51,3.35-9.17,2.04-11.48-.62-1.09-2.1-1.86-4.39-2.29-.27-.05-.52-.08-.79-.08-4.6,0-9.84,8.21-13.69,21.42-.69,2.38-2.91,4.04-5.39,4.04-.68,0-1.35-.12-1.99-.36-6.03-2.28-21.36-7.8-33.43-9.89-9.88-1.71-19.87-2.07-26.5-2.07-1.7,0-3.39.02-5.01.07-.02,0-.14,0-.16,0-1.64,0-3.19-.71-4.26-1.96s-1.54-2.88-1.29-4.51c.49-3.25,1.33-9.24,1.44-12.87.19-6.45-2.14-10.02-6.92-10.6-.38-.05-.74-.07-1.08-.07-4.41,0-5.19,4.13-5.27,13.4-.02,2.18-.04,4.25-.27,5.98-1.21,9.15-5.49,15.8-8.03,19.05.53,1.74.64,3.57.33,5.38-.97,5.62-5.81,9.7-11.51,9.7-.67,0-1.34-.06-2.01-.17-3.08-.53-5.76-2.23-7.56-4.78-1.8-2.55-2.5-5.65-1.96-8.73.96-5.57,5.73-9.62,11.36-9.7.27-2.26.44-5.61-.15-9.35-1.24-7.82-2.39-26.14.44-35.11,3.18-10.1,13.93-20.88,26.41-21.41.29-.01.57-.02.86-.02,9.02,0,15.98,6.02,19.41,9.73,1.5-2.25,3.88-5.49,7.14-8.91-.51.07-1.02.11-1.54.11-.64,0-1.28-.06-1.92-.17-6.07-1.05-10.16-6.85-9.11-12.92.68-3.95,3.41-7.19,7.1-8.57,1.73-4.23,7.94-16.77,20.5-16.77,1.83,0,3.74.28,5.65.83,13.83,3.96,25.6,19.78,34.99,47.04.17.49.31.89.42,1.2,1.3,3.64,2.1,7.17,2.57,9.76,3-1.73,7.81-3.67,14.29-3.67,2.2,0,4.47.23,6.76.68,5.1,1,14.31,5.01,18.71,20.57,3.74,13.22-5.96,34.76-10.31,43.41-1.35,2.69-2.55,5.84-3.36,8.13,4.52,2.16,7.18,7.08,6.29,12.25-.95,5.5-5.69,9.49-11.26,9.49h0ZM74.18,21.53c2.75,2.52,4.09,6.3,3.42,10.13-.07.42-.17.83-.29,1.24,0,0,.02-.01.03-.02,2.88-2.01,7.28-8.16,7.46-12.55.08-1.92-.68-2.79-1.27-3.28-.52-.43-1.04-.63-1.66-.63-2.18,0-5.19,2.34-7.7,5.11Z"
                                />
                                <path
                                  style={{ fill: "white" }}
                                  d="m83.17,5c1.55,0,3.2.23,4.97.73,20.79,5.95,31.79,41.23,33.74,46.67,2.44,6.84,3.05,13.32,3.05,13.32,0,0,5.65-5.57,16.17-5.57,1.93,0,4.02.19,6.28.63,5.68,1.12,13.03,5.54,16.78,18.8s-7.5,36.36-10.14,41.6c-1.97,3.91-3.59,8.65-4.29,10.8,4.7.97,7.82,5.5,6.99,10.26-.75,4.35-4.53,7.41-8.79,7.41-.51,0-1.02-.04-1.53-.13-4.86-.84-8.12-5.47-7.28-10.33.36-2.08,1.41-3.86,2.87-5.15-.66-2.18-2.76-9.79-2.09-16.69,1.02-10.53,12.66-24.55-1.4-27.19-.42-.08-.84-.12-1.25-.12-8.41,0-14.02,16.13-16.08,23.22-.4,1.37-1.65,2.24-2.99,2.24-.37,0-.74-.07-1.1-.2-6.52-2.46-21.71-7.91-33.88-10.02-9.98-1.73-20.03-2.11-26.93-2.11-1.98,0-3.7.03-5.08.07-.03,0-.06,0-.09,0-1.9,0-3.37-1.69-3.08-3.59.57-3.77,1.36-9.53,1.47-13.17.21-7.22-2.53-12.36-9.12-13.15-.49-.06-.95-.09-1.38-.09-9.87,0-7.09,14.6-8.01,21.55-1.31,9.88-6.47,16.68-8.4,18.92.76,1.64,1.05,3.51.71,5.42-.77,4.47-4.66,7.63-9.05,7.63-.52,0-1.05-.04-1.58-.14-5-.87-8.35-5.62-7.49-10.62.77-4.47,4.66-7.63,9.05-7.63.52,0,1.05.04,1.58.14.13.02.24.06.37.08.37-1.82,1.13-6.72.22-12.46-1.16-7.28-2.33-25.45.35-33.97,2.68-8.52,12.12-19.15,24.13-19.66.25-.01.5-.02.75-.02,11.61,0,19.72,11.51,19.72,11.51,0,0,5.92-11.03,17.47-19.09,4.41-3.08,12.41-14.78,6.36-19.8-1.03-.85-2.13-1.21-3.26-1.21-4.83,0-10.1,6.45-11.36,8.09,3.31,1.68,5.28,5.37,4.62,9.22-.73,4.22-4.4,7.2-8.54,7.2-.49,0-.99-.04-1.49-.13-4.72-.82-7.89-5.31-7.07-10.03.61-3.52,3.26-6.18,6.53-6.96.45-1.29,5.99-16.3,18.6-16.3m-17.32,30.75c.82,0,1.55-.59,1.7-1.43.16-.94-.47-1.83-1.4-1.99-.1-.02-.2-.03-.3-.03-.82,0-1.55.59-1.7,1.43-.16.94.47,1.83,1.4,1.99.1.02.2.03.3.03M9.9,122c.98,0,1.84-.7,2.01-1.69.19-1.11-.55-2.17-1.66-2.36-.12-.02-.24-.03-.35-.03-.98,0-1.84.7-2.01,1.69-.19,1.11.55,2.17,1.66,2.36.12.02.24.03.35.03m141.18,24.31c1.04,0,1.95-.74,2.14-1.8.2-1.18-.59-2.3-1.77-2.51-.13-.02-.25-.03-.37-.03-1.04,0-1.95.74-2.14,1.8-.2,1.18.59,2.3,1.77,2.51.13.02.25.03.37.03M83.17,0h0c-13.2,0-20.03,12.04-22.4,17.36-3.99,1.87-6.89,5.59-7.66,10.05-1.21,6.99,3.14,13.68,9.84,15.52-.85,1.04-1.62,2.03-2.29,2.94-4.15-3.84-10.8-8.37-19.07-8.37-.32,0-.64,0-.96.02-14.08.6-25.29,12.38-28.69,23.15-3.19,10.12-1.5,30.12-.52,36.26.4,2.49.43,4.8.32,6.67-5.81,1.01-10.48,5.56-11.52,11.56-.65,3.73.2,7.5,2.38,10.6,2.18,3.1,5.44,5.16,9.18,5.81.8.14,1.62.21,2.43.21,6.92,0,12.79-4.95,13.97-11.77.3-1.76.28-3.53-.08-5.25,2.73-3.73,6.62-10.4,7.79-19.28.25-1.89.27-4.02.29-6.29.03-3.19.06-6.8.81-9.15.56-1.77,1.06-1.77,1.96-1.77.24,0,.5.02.78.05,1.48.18,4.95.6,4.73,8.04-.08,2.59-.58,7.05-1.41,12.57-.35,2.34.33,4.72,1.87,6.51,1.54,1.8,3.79,2.83,6.16,2.83.08,0,.16,0,.24,0,1.59-.05,3.25-.07,4.94-.07,6.54,0,16.37.35,26.07,2.03,11.86,2.05,27.01,7.51,32.97,9.77.92.35,1.89.53,2.87.53,3.58,0,6.79-2.4,7.79-5.85,3.71-12.74,8.58-19.62,11.28-19.62.1,0,.21.01.32.03,1.83.34,2.55.85,2.68,1.07.74,1.3-1.11,6.36-2.21,9.38-1.35,3.7-2.75,7.52-3.12,11.35-.57,5.92.57,12.05,1.54,15.93-1.14,1.65-1.93,3.55-2.27,5.54-.64,3.67.2,7.36,2.34,10.41,2.14,3.04,5.35,5.07,9.01,5.7.79.14,1.59.21,2.39.21,6.79,0,12.56-4.86,13.72-11.56.95-5.5-1.41-10.77-5.69-13.77.71-1.88,1.58-4.02,2.53-5.9,5.56-11.07,14.32-31.66,10.48-45.21-4.76-16.84-14.97-21.23-20.63-22.34-2.44-.48-4.88-.73-7.24-.73-5.12,0-9.32,1.14-12.5,2.5-.49-2.12-1.14-4.5-2.01-6.94-.11-.3-.24-.69-.41-1.17C116.5,21.48,104.17,5.12,89.51.92,87.36.31,85.23,0,83.17,0h0Zm-5.56,21.61c1.81-1.69,3.45-2.69,4.27-2.69.01,0,.03.02.07.05.16.13.41.34.37,1.25-.07,1.76-1.13,4.07-2.46,6.12-.44-1.71-1.2-3.31-2.24-4.73h0Z"
                                />
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    ) : data.filter((product: any) => product.day === item.day)
                        .length > 0 ? (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                        onClick={() => showDetail(item)}>
                        <div
                          style={{
                            background:
                              "linear-gradient(73deg, #EA3434 27.49%, #C81F1F 51.6%, #AB0E0E 75.72%, #A00808 90.19%)",
                            padding: "20%",
                            borderRadius: "200px",
                          }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="31"
                            height="25"
                            viewBox="0 0 31 25"
                            fill="none">
                            <g clipPath="url(#clip0_267_2059)">
                              <path
                                d="M0 8.69442L3.69761 25L29.9807 23.07L31 5.07096L22.2007 12.1192L15.5 0L9.43891 12.5024L0 8.69442Z"
                                fill="#FFC446"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_267_2059">
                                <rect width="31" height="25" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    ) : (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                        onClick={() => showDetail(item)}>
                        <div
                          style={{
                            backgroundColor: "#C8C8C8",
                            padding: "20%",
                            borderRadius: "200px",
                          }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="31"
                            height="25"
                            viewBox="0 0 31 25"
                            fill="none">
                            <g clipPath="url(#clip0_267_2049)">
                              <path
                                d="M0 8.69442L3.69761 25L29.9807 23.07L31 5.07096L22.2007 12.1192L15.5 0L9.43891 12.5024L0 8.69442Z"
                                fill="#7B8189"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_267_2049">
                                <rect width="31" height="25" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign: "center" }}>
              <Button
                onClick={showListCoupon}
                style={{
                  backgroundColor: "#E84137",
                  color: "white",
                  fontWeight: "bold",
                  bottom: 0,
                  margin: "30px auto",
                  borderRadius: 20,
                  position: "relative",
                  paddingLeft: 15,
                  paddingRight: 50,
                }}>
                VER LISTADO DE PREMIOS
                <img
                  style={{ width: 50, position: "absolute", right: 0 }}
                  src={star} alt="stars"></img>
              </Button>
            </div>
          </div>
        )}
      </>
    );
}

export default Summary